import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logo from "./assets/logo.png"; // adapte le chemin

export default function Splash() {
  const navigate = useNavigate();
  const goNext = () => navigate("/menu");

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Enter" || e.key === " ") goNext();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <div
      onClick={goNext}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh", // plein écran vertical
        width: "100vw", // plein écran horizontal
        background: "#000",
        color: "#fff",
        cursor: "pointer",
        userSelect: "none",
      }}
      title="Cliquer pour continuer"
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 16,
        }}
      >
        <img
          src={logo}
          alt="Logo"
          style={{
            width: 160,
            height: 160,
            objectFit: "contain",
            borderRadius: 24,
          }}
          draggable="false"
        />
      </div>
    </div>
  );
}
